module.exports = __webpack_public_path__ + "static/media/tinyDisconnected.4df7c970.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tinyDisconnected.svg
// module id = 503
// module chunks = 0